import React, { FC, VFC, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './PaymentRequest.scss';
import { Button } from '../../../components/Button';
import { Order, Appointments } from '../types';
import petimg from '@/assets/img/user-icon1.png';
import CardIcon from '@/assets/img/icon-card.svg';
import { ReactComponent as EditIcon } from '@/assets/img/v2/edit-pencil-icon.svg';
import moment from 'moment-timezone';
import PetsIcon from '@/assets/img/profile-pic.svg';
import { useRetryPayment, usePayNow } from '../api/retryPayment';
import { PetskedTitle } from '@/components/Heading/PetskedTitle';
import BackIcon from '@/assets/img/back-icon.svg';
import { showNotification } from '@/utils/notificationUtils';
import { UseScreenOrientation } from '@/utils/Orientation';
import PAYMENT_TYPES from '@/config/constants';
import Utils from '@/utils/util';
import { PetConfirmationDisplay } from './PetConfirmationDisplay';
import BoardingPetInfo from './BoardingPetInfo';
import { useTranslation } from 'react-i18next';
import { LineItem, useUpdateAppoinment } from '../api/updatePayment';
import storage from '@/utils/storage';
import { businessCurrency } from '@/features/Language/api/getCountryCurrency';

type RequestPaymentProps = {
  open: boolean;
  onClose: (refresh: boolean) => void;
  onConfirm: (lineItem: LineItem) => void;
  selectedAppointment: Appointments;
  onBackToList: () => void;
};
const PaymentRequest = ({
  open,
  onClose,
  onConfirm,
  selectedAppointment,
  onBackToList,
}: RequestPaymentProps) => {
  const PAYMENT_STATUS = {
    PAYMENT_REQUESTED: 'Payment requested',
    PAYMENT_COMPLETED: 'Payment completed',
    REQUEST_PAYMENT: 'Pay Now',
    REFUND_PAYMENT: 'Refund',
  };

  const country = storage.getKey('country');
  const retryPaymentMutation = useRetryPayment();
  const updateAppointmentMutation = useUpdateAppoinment();
  const isLandscape = UseScreenOrientation();
  const payNowMotation = usePayNow();
  const [showMore, setShowMore] = useState(false);

  const { t } = useTranslation();

  const [tippingCharges, setTippingCharges] = useState<any>(0);
  const [editTippingCharges, setEditTippingCharges] = useState(false);
  const [lineItem, setLineItem] = useState<LineItem>();
  useEffect(() => {
    setLineItem({
      advPayment: selectedAppointment.advPayment,
      othCharges: selectedAppointment.othCharges,
      serviceTip: selectedAppointment.serviceTip,
      storeDisc: selectedAppointment.storeDisc,
      subTotal: selectedAppointment.subTotal,
      total: selectedAppointment.total,
    });
    setTippingCharges(selectedAppointment?.serviceTip?.toString());
  }, []);

  const getPaymentStatusFromOrder = (item: Order) => {
    if (PAYMENT_TYPES.FAILURE.indexOf(item.paymentStatus || '') >= 0) {
      return 'Failure';
    }

    if (PAYMENT_TYPES.SUCCESS.indexOf(item.paymentStatus || '') >= 0) {
      return 'Success';
    }

    return 'Pending';
  };
  const trx =
    selectedAppointment.orders && selectedAppointment.orders[selectedAppointment.orders.length - 1];

  const findUnsuccessfulTransactions = (orders: any) => {
    for (const order of orders) {
      if (['succeeded', 'COMPLETED'].indexOf(order.paymentStatus) < 0 && order.paymentLink) {
        return order.paymentLink;
      }
    }
    return null;
  };

  const getPaymentStatus = () => {
    const orderArray =
      selectedAppointment?.orders && selectedAppointment?.orders.length > 0
        ? selectedAppointment?.orders
        : [];
    for (const order of orderArray) {
      if (!order.isAdvancePayment) {
        if (order.paymentStatus === null) {
          return PAYMENT_STATUS.PAYMENT_REQUESTED;
        } else if (order.paymentStatus !== null) {
          return PAYMENT_STATUS.PAYMENT_COMPLETED;
        } else {
          // if (currentBalanceAmount < 0) {
          //   return 'Refund Amount';
          // }
          return PAYMENT_STATUS.REQUEST_PAYMENT;
        }
      }
    }
    if (lineItem?.total && lineItem?.total < 0) {
      return PAYMENT_STATUS.REFUND_PAYMENT;
    }
    return PAYMENT_STATUS.REQUEST_PAYMENT;
  };
  const applyTippingCharges = async () => {
    if (tippingCharges === undefined || parseFloat(tippingCharges as string) < 0) {
      showNotification({ type: 'warning', title: 'Please enter valid data for tips.' });
      return;
    }
    const res = await updateAppointmentMutation.mutateAsync({
      id: Number(selectedAppointment?.id),
      serviceTip: tippingCharges ? Number(tippingCharges) : 0,
    });
    const lineItem: LineItem = {
      subTotal: res.subTotal ? res.subTotal : 0,
      othCharges: res.othCharges ? res.othCharges : 0,
      storeDisc: res.storeDisc ? res.storeDisc : 0,
      total: res.total ? res.total : 0,
      advPayment: res.advPayment ? res.advPayment : 0,
      serviceTip: res.serviceTip ? res.serviceTip : 0,
    };
    setTippingCharges(res.serviceTip);
    setLineItem(lineItem);
    setEditTippingCharges(false);
  };
  const successfullTransaction = findUnsuccessfulTransactions(selectedAppointment.orders);
  const paymentStatus = getPaymentStatus();
  const petData = selectedAppointment.pet
    ? [selectedAppointment.pet]
    : selectedAppointment.pets && selectedAppointment.pets.length > 0 ? selectedAppointment.pets : [];
  return (
    <>
      {!isLandscape ? (
        <>
          <div className="back-nav-new" onClick={onBackToList}>
            <img src={BackIcon} alt="back icon" />
            <span>{t('Back')}</span>
          </div>
          <PetskedTitle
            title={t("Make payment")}
            highlightTitle=""
            size="lg"
            alignText="left"
            description={
              selectedAppointment.room
                ? t('Make payment for the bookings below')
                : t('Make payment for the service below')
            }
            noPadding="no-padding"
          />
          <div className="scroll-45 payment-modal">
            {petData && (
              <BoardingPetInfo
                data={petData}
                accomodationType={selectedAppointment?.accomodationType}
              />
            )}

            <div className="icon-profile">
              <div className="icon-pic-block">
                <img className="icon-pic" src={CardIcon} />
              </div>
              <div className="icon-info-block">
                <div className="icon-name">{selectedAppointment?.petParent?.name}</div>
                <div className="icon-email">
                  <span className="mail-text">{selectedAppointment?.petParent?.email}</span>
                  {/* <span className="line-left">
                            {selectedAppointment?.petParent?.phone
                              ? Utils.formatPhoneNumber(selectedAppointment?.petParent?.phone)
                              : ''}
                          </span> */}
                </div>
              </div>
            </div>
            <div className="more-detail-block">
              <div className="service-row">
                <div className="service-name">
                  {selectedAppointment?.service
                    ? selectedAppointment?.service?.name
                    : selectedAppointment?.room
                    ? selectedAppointment?.accomodationType === Utils.ACCOMODATION_TYPES.DAY_CARE
                      ? 'DayCare service'
                      : 'Boarding service'
                    : ''}
                </div>
                <div className="service-name">
                {businessCurrency(country,'USD')} {Utils.roundDecimal(selectedAppointment.servicePrice)}
                </div>
              </div>
              <div className="service-row desc-row">
                <div className="service-desc">
                  {selectedAppointment?.service?.description
                    ? selectedAppointment?.service?.description
                    : ''}
                </div>
                <div className="service-desc">
                  {`${
                    selectedAppointment?.accomodationType === Utils.ACCOMODATION_TYPES.BOARDING
                      ? parseInt(selectedAppointment?.duration) > 1 ? selectedAppointment?.duration + ' Days' : selectedAppointment?.duration + ' Day' 
                      : Utils.getDuration(parseFloat(selectedAppointment?.duration))
                  }`}
                </div>
              </div>
              {showMore &&
                (selectedAppointment.room ? (
                  <>
                    <div className="duration-row">
                      <div className="duration-txt">{t('Check-In time')}</div>
                      <div className="duration-date">
                        {Utils.formatDateStringTz(
                          selectedAppointment?.startTime,
                          selectedAppointment.businessLocation?.timezone,
                          "DD MMM 'yy, hh:mma"
                        )}
                      </div>
                    </div>
                    <div className="duration-row">
                      <div className="duration-txt">{t('Check-Out time')}</div>
                      <div className="duration-date">
                        {Utils.formatDateStringTz(
                          selectedAppointment?.endTime,
                          selectedAppointment.businessLocation?.timezone,
                          "DD MMM 'yy, hh:mma"
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="duration-txt">{t('Date & duration')}</div>
                    <div className="mb-duration">
                      <div className="duration-date">
                        {Utils.formatDateStringTz(
                          selectedAppointment.startTime,
                          selectedAppointment.businessLocation.timezone,
                          'ddd, DD MMM, yyyy'
                        )}
                      </div>
                      <div className="duration-time">
                        {Utils.formatDateStringTz(
                          selectedAppointment?.startTime,
                          selectedAppointment.businessLocation.timezone,
                          'hh:mma'
                        )}{' '}
                        -{' '}
                        {Utils.formatDateStringTz(
                          selectedAppointment?.endTime,
                          selectedAppointment.businessLocation.timezone,
                          'hh:mma'
                        )}
                        <span>
                          {' '}
                          {`(${Utils.getDuration(parseFloat(selectedAppointment?.duration))})`}
                        </span>
                      </div>
                    </div>

                    <div className="duration-txt">{t('Service provider')}</div>
                    <div className="pay-profile padding-13">
                      <div className="pay-pic-block">
                        <img className="pay-pic" src={petimg} />
                      </div>
                      <div className="pay-info-block">
                        <div className="pay-name">{selectedAppointment?.businessUser?.name}</div>
                        <div className="pay-email">{selectedAppointment?.businessUser?.email}</div>
                      </div>
                    </div>
                  </>
                ))}
              <div className="more-detail-row">
                <div
                  className="more-detail-text"
                  onClick={() => {
                    setShowMore(!showMore);
                  }}
                >
                  {showMore ? t('- Less details') : t('+ More details')}
                </div>
              </div>
            </div>
            <div className="payment-detail-block">
              {selectedAppointment?.addonServices && selectedAppointment?.addonServices.length > 0 && (
                <div className="total-pay-row-amt mt-10">
                  <div className="amount-tax">{t('Addon Services')}</div>
                  <div className="dah-line"></div>
                  <div className="amount-dark">
                  {businessCurrency(country,'USD')} {Utils.roundDecimal(selectedAppointment.addonPrice)}
                  </div>
                </div>
              )}
              <div className="total-pay-row-amt mt-10">
                <div className="amount-tax">{t('Subtotal')}</div>
                <div className="dah-line"></div>
                <div className="amount-dark">
                {businessCurrency(country,'USD')} {Utils.roundDecimal(lineItem?.subTotal)}
                </div>
              </div>

              <div className="total-pay-row-amt">
                <div className="amount-tax">{t('Advance payment')}</div>
                <div className="dah-line"></div>
                <div className="amount-light">
                  - {businessCurrency(country,'USD')} {Utils.roundDecimal(lineItem?.advPayment)}
                </div>
              </div>
              <div className="total-pay-row-amt">
                <div className="amount-tax">{t('Store discount (optional)')}</div>
                <div className="dah-line"></div>
                <div className="amount-light">
                  - {businessCurrency(country,'USD')} {Utils.roundDecimal(lineItem?.storeDisc)}
                </div>
              </div>

              <div className="total-pay-row-amt">
                <div className="amount-tax">{t('Other Charges')}</div>
                <div className="dah-line"></div>
                <div className="amount-light">
                  + {businessCurrency(country,'USD')} {Utils.roundDecimal(lineItem?.othCharges)}
                </div>
              </div>

              {!selectedAppointment?.accomodationType && (
                <div className="total-pay-row-amt">
                  <div className="left-label">
                    <div className="amount-tax other-amouht-width">
                      <div className="optional">Tips</div>{' '}
                      <div>
                        {paymentStatus.toLowerCase() ===
                          PAYMENT_STATUS.REQUEST_PAYMENT.toLowerCase() && (
                          <div className="edit-other-amt">
                            <EditIcon onClick={() => {
                                setEditTippingCharges(true);
                              }}/>
                            add
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="dah-line"></div>
                  </div>
                  <div className="amount-light">
                    +{businessCurrency(country,'USD')} {Utils.roundDecimal(lineItem?.serviceTip)}{' '}
                  </div>
                </div>
              )}

              {editTippingCharges && (
                <div className="total-pay-row-amt">
                  <div className="edit-price-div">
                    <div className="other-charges-divider"></div>
                    <div className="other-changes-text-div">
                      <div className="other-changes-text-div">Add tipping charges</div>
                      <div
                        className="other-changes-text-div pink-clr"
                        onClick={() => {
                          setEditTippingCharges(false);
                          setTippingCharges(lineItem?.serviceTip);
                        }}
                      >
                        - Cancel
                      </div>
                    </div>
                    <div className="edit-price-block input-prifix-text">
                      <div className="relative rounded-md">
                        <div className="pointer-events-none absolute input-prifix">
                          <span className="text-gray-500 sm:text-sm usd-text-font">
                          {businessCurrency(country,'USD')} {' '}
                          </span>
                          <span className="text-gray-500 sm:text-sm edit-price-line"> |</span>
                        </div>
                        <input
                          type="text"
                          name="weight"
                          id="weight"
                          className="new-cust-input adding-padding"
                          placeholder="Enter tipping charge"
                          onChange={(e: any) => {
                            setTippingCharges(e.target.value);
                          }}
                          value={tippingCharges}
                          maxLength={8}
                        />
                      </div>
                      <Button
                        variant="inverse"
                        size="sm"
                        onClick={applyTippingCharges}
                        className="apply-btn"
                        disabled={updateAppointmentMutation.isLoading}
                      >
                        {updateAppointmentMutation.isLoading ? 'Applying' : 'Apply'}
                      </Button>
                    </div>
                    <div className="cards-tipping">
                      <div
                        className={`tipping-card ${tippingCharges === '1' ? 'selected' : ''}`}
                        onClick={() => setTippingCharges('1')}
                      >
                        {businessCurrency(country,'USD')} 1
                      </div>
                      <div
                        className={`tipping-card ${tippingCharges === '2' ? 'selected' : ''}`}
                        onClick={() => setTippingCharges('2')}
                      >
                        {businessCurrency(country,'USD')} 2
                      </div>
                      <div
                        className={`tipping-card ${tippingCharges === '5' ? 'selected' : ''}`}
                        onClick={() => setTippingCharges('5')}
                      >
                        {businessCurrency(country,'USD')} 5
                      </div>
                      <div
                        className={`tipping-card ${tippingCharges === '10' ? 'selected' : ''}`}
                        onClick={() => setTippingCharges('10')}
                      >
                        {businessCurrency(country,'USD')} 10
                      </div>
                      </div>
                    <div className="other-charges-divider"></div>
                  </div>
                </div>
              )}
              <div className="total-pay-row">
                <div className="total-text">
                  {paymentStatus.toLowerCase() === PAYMENT_STATUS.REFUND_PAYMENT.toLowerCase()
                    ? 'Refund Amount'
                    : paymentStatus.toLowerCase() === PAYMENT_STATUS.REQUEST_PAYMENT.toLowerCase()
                    ? 'Total payable'
                    : 'Total paid'}
                </div>
                <div className="total-text total-amounnt">
                {businessCurrency(country,'USD')} {Utils.roundDecimal(Utils.roundDecimal(lineItem?.total))}
                </div>
              </div>
            </div>
          </div>
          {Number(selectedAppointment.servicePrice) !== 0 && (
            <div className="mobile-btn-div">
              {trx && !trx.isRetrySuccessful && getPaymentStatusFromOrder(trx) === 'Failure' ? (
                <Button
                  variant="primary"
                  size="lg"
                  onClick={async (ev: any) => {
                    ev.preventDefault();
                    await retryPaymentMutation.mutateAsync({
                      orderId: trx.id,
                      roomId: selectedAppointment?.room?.id,
                    });
                    lineItem && onConfirm(lineItem);
                  }}
                  disabled={retryPaymentMutation.isLoading}
                >
                  {t('Retry Payment')}
                </Button>
              ) : successfullTransaction !== null ? (
                <a href={successfullTransaction} target="_blank" rel="noreferrer">
                  <Button variant="primary" size="lg">
                    {t('Retry payment')}
                  </Button>
                </a>
              ) : trx && getPaymentStatusFromOrder(trx) === 'Pending' && trx.paymentLink ? (
                <a href={trx.paymentLink} target="_blank" rel="noreferrer">
                  <Button
                    variant="primary"
                    size="lg"
                    onClick={async () => {
                      if (selectedAppointment.orders && selectedAppointment.orders.length > 0) {
                        lineItem && onConfirm(lineItem);
                      }
                    }}
                    disabled={retryPaymentMutation.isLoading}
                  >
                    {t('Pay Now')}
                  </Button>
                </a>
              ) : (
                <Button
                  variant="primary"
                  size="lg"
                  onClick={async () => {
                    if (selectedAppointment?.id) {
                      const res = await payNowMotation.mutateAsync({
                        appId: selectedAppointment?.id,
                        roomId: selectedAppointment.room ? selectedAppointment.room.id : undefined,
                      });
                      if (
                        res &&
                        res.order &&
                        res.order.paymentStatus &&
                        PAYMENT_TYPES.SUCCESS.indexOf(res.order.paymentStatus) >= 0
                      ) {
                        showNotification({
                          type: 'success',
                          title: t('Payment completed successfully'),
                        });
                        lineItem && onConfirm(lineItem);
                      }
                    }
                  }}
                  disabled={
                    payNowMotation.isLoading ||
                    paymentStatus.toLowerCase() !== PAYMENT_STATUS.REQUEST_PAYMENT.toLowerCase() ||
                    (selectedAppointment?.isComplete ? true : false)
                  }
                >
                  {selectedAppointment?.isComplete ? t('Payment Completed') : paymentStatus}
                </Button>
              )}
            </div>
          )}
        </>
      ) : (
        <Modal
          show={open}
          onHide={() => onClose(true)}
          className="petsked-modal-dialog  edit-member-dialog payment-modal"
        >
          <Modal.Header closeButton>
            <PetskedTitle
              title={t("Make payment")}
              highlightTitle=""
              size="lg"
              alignText="left"
              description={t("Make payment for the service below")}
              noPadding="no-padding"
            />
          </Modal.Header>

          <Modal.Body>
            <div className="scroll-45">
              <div className="payment-detail-profile-block">
                {petData && (
                  <BoardingPetInfo
                    data={petData}
                    accomodationType={selectedAppointment?.accomodationType}
                  />
                )}
                <div className="icon-profile">
                  <div className="icon-pic-block">
                    <img className="icon-pic" src={CardIcon} />
                  </div>
                  <div className="icon-info-block">
                    <div className="icon-name">{selectedAppointment?.petParent?.name}</div>
                    <div className="icon-email">
                      <span className="mail-text">{selectedAppointment?.petParent?.email}</span>
                      <span className="line-left">
                        {selectedAppointment?.petParent?.phone
                          ? Utils.formatPhoneNumber(selectedAppointment?.petParent?.phone)
                          : ''}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="more-detail-block">
                <div className="service-row">
                  <div className="service-name">
                    {selectedAppointment?.service
                      ? selectedAppointment?.service?.name
                      : selectedAppointment?.accomodationType === Utils.ACCOMODATION_TYPES.DAY_CARE
                      ? t('DayCare service')
                      : t('Boarding service')}
                  </div>
                  <div className="service-name">
                  {businessCurrency(country,'USD')} {Utils.roundDecimal(selectedAppointment.servicePrice)}
                  </div>
                </div>
                <div className="service-row desc-row">
                  <div className="service-desc">
                    {selectedAppointment?.service?.description
                      ? selectedAppointment?.service?.description
                      : ''}
                  </div>
                  <div className="service-desc">
                    {`${
                      selectedAppointment?.accomodationType === Utils.ACCOMODATION_TYPES.BOARDING
                        ? parseInt(selectedAppointment?.duration) > 1 ? selectedAppointment?.duration + ' days' : selectedAppointment?.duration + ' day' 
                        : Utils.getDuration(parseFloat(selectedAppointment?.duration))
                    }`}
                  </div>
                </div>
                {showMore &&
                  (selectedAppointment.room ? (
                    <>
                      <div className="duration-row">
                        <div className="duration-txt">{t('Check-In time')}</div>
                        <div className="duration-date">
                          {Utils.formatDateStringTz(
                            selectedAppointment?.startTime,
                            selectedAppointment.businessLocation?.timezone,
                            "DD MMM 'yy, hh:mma"
                          )}
                        </div>
                      </div>
                      <div className="duration-row">
                        <div className="duration-txt">{t('Check-Out time')}</div>
                        <div className="duration-date">
                          {Utils.formatDateStringTz(
                            selectedAppointment?.endTime,
                            selectedAppointment.businessLocation?.timezone,
                            "DD MMM 'yy, hh:mma "
                          )}
                        </div>
                      </div>
                      <hr />
                      {selectedAppointment.accomodationType && selectedAppointment?.pets && (
                        <div className="pet-list-display">
                          {petData.map((pet, index) => (
                            <PetConfirmationDisplay data={pet} showPrice={true} />
                          ))}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="duration-row">
                        <div className="duration-txt">{t('Date & duration')}</div>
                        <div className="duration-date">
                          {Utils.formatDateStringTz(
                            selectedAppointment.startTime,
                            selectedAppointment.businessLocation.timezone,
                            'ddd, DD MMM, yyyy'
                          )}{' '}
                        </div>
                        <div className="duration-time">
                          {Utils.formatDateStringTz(
                            selectedAppointment?.startTime,
                            selectedAppointment.businessLocation.timezone,
                            'hh:mm A'
                          )}{' '}
                          -{' '}
                          {Utils.formatDateStringTz(
                            selectedAppointment?.endTime,
                            selectedAppointment.businessLocation.timezone,
                            'hh:mm A'
                          )}
                          <span>{`(${Utils.getDuration(
                            parseFloat(selectedAppointment?.duration)
                          )})`}</span>
                        </div>
                      </div>
                      <div className="duration-row second-row">
                        <div className="duration-txt">{t('Service provider')}</div>
                        <div className="pay-profile padding-13">
                          <div className="pay-pic-block">
                            <img className="pay-pic" src={petimg} />
                          </div>
                          <div className="pay-info-block">
                            <div className="pay-name">
                              {selectedAppointment?.businessUser?.name}
                            </div>
                            <div className="pay-email">
                              {selectedAppointment?.businessUser?.email}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                <div className="more-detail-row">
                  <div
                    className="more-detail-text"
                    onClick={() => {
                      setShowMore(!showMore);
                    }}
                  >
                    {showMore ? '- Less details' : '+ More details'}
                  </div>
                </div>
              </div>
              <div className="payment-detail-block">
                {selectedAppointment?.addonServices &&
                  selectedAppointment?.addonServices.length > 0 && (
                    <div className="total-pay-row-amt mt-10">
                      <div className="amount-tax">{t('Addon Services')}</div>
                      <div className="dah-line"></div>
                      <div className="amount-dark">
                      {businessCurrency(country,'USD')} {Utils.roundDecimal(selectedAppointment.addonPrice)}
                      </div>
                    </div>
                  )}
                <div
                  className={
                    selectedAppointment?.addonServices &&
                    selectedAppointment?.addonServices.length > 0
                      ? 'total-pay-row-amt'
                      : 'total-pay-row-amt mt-10'
                  }
                >
                  <div className="amount-tax">{t('Subtotal')}</div>
                  <div className="dah-line"></div>
                  <div className="amount-dark">
                  {businessCurrency(country,'USD')} {lineItem?.subTotal}
                  </div>
                </div>
                <div className="total-pay-row-amt">
                  <div className="amount-tax">{t('Advance payment')}</div>
                  <div className="dah-line"></div>
                  <div className="amount-light">
                    - {businessCurrency(country,'USD')} {Utils.roundDecimal(lineItem?.advPayment)}
                  </div>
                </div>

                <div className="total-pay-row-amt">
                  <div className="amount-tax">{t('Store discount (optional)')}</div>
                  <div className="dah-line"></div>
                  <div className="amount-light">
                    - {businessCurrency(country,'USD')} {Utils.roundDecimal(lineItem?.storeDisc)}
                  </div>
                </div>

                <div className="total-pay-row-amt">
                  <div className="amount-tax">{t('Other Charges')}</div>
                  <div className="dah-line"></div>
                  <div className="amount-light">
                    + {businessCurrency(country,'USD')} {Utils.roundDecimal(lineItem?.othCharges)}
                  </div>
                </div>
                {!selectedAppointment?.accomodationType && (
                  <div className="total-pay-row-amt">
                    <div className="left-label">
                      <div className="amount-tax other-amouht-width">
                        <div className="optional">Tips</div>{' '}
                        <div>
                          {paymentStatus.toLowerCase() ===
                            PAYMENT_STATUS.REQUEST_PAYMENT.toLowerCase() && (
                            <div
                              className="edit-other-amt"
                              onClick={() => {
                                setEditTippingCharges(true);
                              }}
                            >
                              <EditIcon />
                              add
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="dah-line"></div>
                    </div>
                    <div className="amount-light">
                      +{businessCurrency(country,'USD')} {Utils.roundDecimal(lineItem?.serviceTip)}{' '}
                    </div>
                  </div>
                )}
                {editTippingCharges && (
                  <div className="total-pay-row-amt">
                    <div className="edit-price-div">
                      <div className="other-charges-divider"></div>
                      <div className="other-changes-text-div">
                        <div className="other-changes-text-div">Add tipping charges</div>
                        <div
                          className="other-changes-text-div pink-clr"
                          onClick={() => {
                            setEditTippingCharges(false);
                            setTippingCharges(lineItem?.serviceTip);
                          }}
                        >
                          - Cancel
                        </div>
                      </div>
                      <div className="edit-price-block input-prifix-text">
                        <div className="relative rounded-md">
                          <div className="pointer-events-none absolute input-prifix">
                            <span className="text-gray-500 sm:text-sm usd-text-font">
                            {businessCurrency(country,'USD')} {' '}
                            </span>
                            <span className="text-gray-500 sm:text-sm edit-price-line"> |</span>
                          </div>
                          <input
                            type="text"
                            name="weight"
                            id="weight"
                            className="new-cust-input adding-padding"
                            placeholder="Enter tipping charge"
                            onChange={(e: any) => {
                              setTippingCharges(e.target.value);
                            }}
                            value={tippingCharges}
                            maxLength={8}
                          />
                        </div>
                        <Button
                          variant="inverse"
                          size="sm"
                          onClick={applyTippingCharges}
                          className="apply-btn"
                          disabled={updateAppointmentMutation.isLoading}
                        >
                          {updateAppointmentMutation.isLoading ? 'Applying' : 'Apply'}
                        </Button>
                      </div>
                      <div className="cards-tipping">
                      <div
                        className={`tipping-card ${tippingCharges === '1' ? 'selected' : ''}`}
                        onClick={() => setTippingCharges('1')}
                      >
                        {businessCurrency(country,'USD')} 1
                      </div>
                      <div
                        className={`tipping-card ${tippingCharges === '2' ? 'selected' : ''}`}
                        onClick={() => setTippingCharges('2')}
                      >
                        {businessCurrency(country,'USD')} 2
                      </div>
                      <div
                        className={`tipping-card ${tippingCharges === '5' ? 'selected' : ''}`}
                        onClick={() => setTippingCharges('5')}
                      >
                        {businessCurrency(country,'USD')} 5
                      </div>
                      <div
                        className={`tipping-card ${tippingCharges === '10' ? 'selected' : ''}`}
                        onClick={() => setTippingCharges('10')}
                      >
                        {businessCurrency(country,'USD')} 10
                      </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="total-pay-row">
                  <div className="total-text">
                    {paymentStatus.toLowerCase() === PAYMENT_STATUS.REFUND_PAYMENT.toLowerCase()
                      ? t('Refund Amount')
                      : paymentStatus.toLowerCase() === PAYMENT_STATUS.REQUEST_PAYMENT.toLowerCase()
                      ? t('Total payable')
                      : t('Total paid')}
                  </div>
                  <div className="total-text total-amounnt">
                  {businessCurrency(country,'USD')} {Utils.roundDecimal(lineItem?.total)}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          {Number(selectedAppointment.servicePrice) !== 0 && (
            <Modal.Footer>
              {trx && !trx.isRetrySuccessful && getPaymentStatusFromOrder(trx) === 'Failure' ? (
                <Button
                  variant="primary"
                  size="lg"
                  onClick={async (ev: any) => {
                    ev.preventDefault();
                    await retryPaymentMutation.mutateAsync({ orderId: trx.id });
                    lineItem && onConfirm(lineItem);
                  }}
                  disabled={retryPaymentMutation.isLoading}
                >
                  {t('Retry Payment')}
                </Button>
              ) : successfullTransaction !== null ? (
                <a href={successfullTransaction} target="_blank" rel="noreferrer">
                  <Button variant="primary" size="lg">
                    {t('Retry payment')}
                  </Button>
                </a>
              ) : trx && getPaymentStatusFromOrder(trx) === 'Pending' && trx.paymentLink ? (
                <a href={trx.paymentLink} target="_blank" rel="noreferrer">
                  <Button
                    variant="primary"
                    size="lg"
                    onClick={async () => {
                      if (selectedAppointment.orders && selectedAppointment.orders.length > 0) {
                        // await retryPaymentMutation.mutateAsync({ orderId: trx.id });
                        lineItem && onConfirm(lineItem);
                        // if (!requestPaymentMutation.isLoading) {
                        //   if (selectedPrice) {
                        //     await requestPaymentMutation.mutateAsync({
                        //       id: Number(selectedAppointment?.id),
                        //       amount: Number(selectedPrice),
                        //     });
                        //     onConfirm();
                        //   }
                        // }
                      }
                    }}
                    disabled={retryPaymentMutation.isLoading}
                  >
                    {t('Pay Now')}
                  </Button>
                </a>
              ) : (
                <Button
                  variant="primary"
                  size="lg"
                  onClick={async () => {
                    if (selectedAppointment?.id) {
                      const res = await payNowMotation.mutateAsync({
                        appId: selectedAppointment?.id,
                        roomId: selectedAppointment.room ? selectedAppointment.room.id : undefined,
                      });
                      if (res && res.paymentLink) {
                        window.open(res.paymentLink, '_blank');
                      } else {
                        if (
                          res &&
                          res.order &&
                          res.order.paymentStatus &&
                          PAYMENT_TYPES.SUCCESS.indexOf(res.order.paymentStatus) >= 0
                        ) {
                          showNotification({
                            type: 'success',
                            title: t('Payment completed successfully'),
                          });
                          lineItem && onConfirm(lineItem);
                        }
                      }
                    }
                  }}
                  disabled={
                    payNowMotation.isLoading ||
                    paymentStatus.toLowerCase() !== PAYMENT_STATUS.REQUEST_PAYMENT.toLowerCase() ||
                    (selectedAppointment?.isComplete ? true : false)
                  }
                >
                  {selectedAppointment?.isComplete ? t('Payment Completed') : paymentStatus}
                </Button>
              )}
            </Modal.Footer>
          )}
        </Modal>
      )}
    </>
  );
};

export default PaymentRequest;
